@import '../../../app-brand/entities/entity-layer.module.less';

.row {
  height: 64px;
  background-color: @split-ship-table-row--background-color;
  font-size: 14px;

  td {
    border-top: 1px solid @split-ship-table-cell--border-color;
    padding-left: 16px;
  }
}

.highlighted {
  background-color: @split-ship-table-row--hover--background-color;
}

.split-button {
  visibility: hidden;
}

.hoverable-row {
  &:hover {
    .highlighted();

    .split-button {
      visibility: visible;
    }
  }
}

.sku {
  max-width: 100%;
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
  color: @split-ship-table-cell--subtext--text-color;
}

.disabled {
  color: @split-ship-table-row--disabled--text-color;
}

.button-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.divider {
  border-left: 1px solid @split-ship-table-cell--divider--border-color;
  height: 32px;
}

.shipped-status-icon {
  height: 16px;
  fill: @shipped-status-icon--fill-color;
}

.name-column {
  text-align: left;
  width: 28%;

  .name-column-content {
    padding: 7px 0;
  }
}

.quantity-column {
  text-align: center;
  width: 9%;
}

.shipment-column {
  text-align: left;
  width: 24%;
}

.status-column {
  text-align: left;
  width: 21%;
}

.actions-column {
  text-align: center;
  width: 18%;
}

.status-column-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-name-link {
  max-width: 100%;
  overflow-x: hidden;
  text-align: inherit;
  line-height: 21px;
}
